import { useState } from "react";
import { IoMdClose } from "react-icons/io";
import { useDispatch } from "react-redux";
import { setAppError } from "../../../../store/userSlice";
import nodeinstance from "../../../../nodeInstance";

export default function DocumentsUpload({
  uploadDocuments,
  setUploadDocuments,
  dependentData,
}) {
  console.log("dependentData.....dependentData", dependentData);
  const token = localStorage.getItem("nodeToken");
  const dispatch = useDispatch();
  const [files, setFiles] = useState([]);
  const handleFileChange = (e) => {
    setFiles([...e.target.files]);
  };

  const submitHandler = async (e, files) => {
    e.preventDefault();
    // setLoading(true);
    // console.log("........files.......", filetype);

    for (let file of files) {
      let type = file.name.split(".").pop();
      if (type !== "pdf") {
        dispatch(setAppError({ msg: "All files should be in PDF format" }));
        setLoading(false);
        return;
      }
    }
    const formData = new FormData();
    files.forEach((file) => {
      formData.append("file", file); // Ensure the field name is 'file'
    });

    try {
      const response = await nodeinstance.put(
        `/insurance-dependent/UploadDocuments/${dependentData && dependentData[0].Employee_Unique_Id}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response.status === 200) {
        setUploadDocuments(false);
        dispatch(
          setAppError({ msg: "Successfully uploaded.", color: "success" })
        );
      }
      console.log("success to be seen here......", response);
    } catch (err) {
      console.log("error", err);
      //   setLoading(false);
    }
  };

  return (
    <>
      <div
        className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50 justify-center items-center ${
          uploadDocuments ? "flex" : "hidden"
        }`}
      >
        {/* <div className="max-w-lg w-full h-auto   rounded-md bg-white/95 flex  flex-col p-4 relative"> */}
        <div className="max-w-lg w-full overflow-auto rounded-md bg-white/95 flex flex-col p-4 relative">
          <div className="flex justify-between items-center w-full">
            <h1
              className="text-md font-semibold cursor-pointer"
              onClick={() => {
                setUploadDocuments(false);
              }}
            >
              <IoMdClose />
            </h1>
          </div>
          <form
            onSubmit={(e) => submitHandler(e, files)}
            className="w-full"
          >
            <div className="form-control w-full mt-2">
              <label className="label">
                <span className="label-text">Upload File</span>
              </label>
              <input
                type="file"
                className="file-input file-input-bordered w-full"
                onChange={handleFileChange}
                required
                accept="application/pdf"
                multiple
              />
            </div>
            <div className="flex gap-3 w-full justify-center" style={{ m: 2 }}>
              <button
                type="submit"
                className="p-2 bg-red text-white rounded-md w-full max-w-sm m-2 my-4 flex gap-3 justify-center items-center"
              >
                {" "}
                <p>Submit</p>
                {/* {loading ? <CgSpinner className="animate-spin" /> : ""} */}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
